module.exports = __webpack_public_path__ + "media/images/front/mn_expert_default_ogp-569ca8cf11f55461945fb86b907a0ba0.png";